/* AUTO-GENERATED. Do not edit by hand. */
// Barrel file exporting all generated Remix icon components.
// Import icons like: import { RiHomeLine } from "~/icons/remix"
// Import types like: import type { RemixiconProps } from "~/icons/remix/types"

/**
 * @remixicon/react v4.1.0 - Apache-2.0
 */
import type { ComponentType, SVGProps } from 'react'

type AllSVGProps = SVGProps<SVGSVGElement>
type ReservedProps = 'color' | 'size' | 'width' | 'height' | 'fill' | 'viewBox'
export interface RemixiconProps extends Pick<AllSVGProps, Exclude<keyof AllSVGProps, ReservedProps>> {
  color?: string
  size?: number | string
  children?: never
}
export type RemixiconComponentType = ComponentType<RemixiconProps>

export { default as RiAddLine } from './generated/RiAddLine'
export { default as RiAdvertisementLine } from './generated/RiAdvertisementLine'
export { default as RiAlarmWarningLine } from './generated/RiAlarmWarningLine'
export { default as RiAlertLine } from './generated/RiAlertLine'
export { default as RiArrowDownLine } from './generated/RiArrowDownLine'
export { default as RiArrowDownSLine } from './generated/RiArrowDownSLine'
export { default as RiArrowDropDownFill } from './generated/RiArrowDropDownFill'
export { default as RiArrowDropUpFill } from './generated/RiArrowDropUpFill'
export { default as RiArrowLeftLine } from './generated/RiArrowLeftLine'
export { default as RiArrowRightLine } from './generated/RiArrowRightLine'
export { default as RiArrowRightSLine } from './generated/RiArrowRightSLine'
export { default as RiArrowRightUpLine } from './generated/RiArrowRightUpLine'
export { default as RiArrowUpLine } from './generated/RiArrowUpLine'
export { default as RiArrowUpSLine } from './generated/RiArrowUpSLine'
export { default as RiArticleLine } from './generated/RiArticleLine'
export { default as RiAwardLine } from './generated/RiAwardLine'
export { default as RiBarChartBoxLine } from './generated/RiBarChartBoxLine'
export { default as RiBarChartGroupedLine } from './generated/RiBarChartGroupedLine'
export { default as RiBarChartLine } from './generated/RiBarChartLine'
export { default as RiBook2Line } from './generated/RiBook2Line'
export { default as RiBookLine } from './generated/RiBookLine'
export { default as RiBookmarkLine } from './generated/RiBookmarkLine'
export { default as RiBookOpenLine } from './generated/RiBookOpenLine'
export { default as RiBookReadLine } from './generated/RiBookReadLine'
export { default as RiBriefcaseLine } from './generated/RiBriefcaseLine'
export { default as RiBuilding2Line } from './generated/RiBuilding2Line'
export { default as RiCalculatorLine } from './generated/RiCalculatorLine'
export { default as RiCapsuleLine } from './generated/RiCapsuleLine'
export { default as RiCarouselView } from './generated/RiCarouselView'
export { default as RiChatQuoteLine } from './generated/RiChatQuoteLine'
export { default as RiCheckboxCircleFill } from './generated/RiCheckboxCircleFill'
export { default as RiCheckboxCircleLine } from './generated/RiCheckboxCircleLine'
export { default as RiCheckLine } from './generated/RiCheckLine'
export { default as RiClipboardCheckLine } from './generated/RiClipboardCheckLine'
export { default as RiClipboardLine } from './generated/RiClipboardLine'
export { default as RiClipboardListLine } from './generated/RiClipboardListLine'
export { default as RiCloseCircleFill } from './generated/RiCloseCircleFill'
export { default as RiClosedCaptioningFill } from './generated/RiClosedCaptioningFill'
export { default as RiCloseLine } from './generated/RiCloseLine'
export { default as RiCloudLine } from './generated/RiCloudLine'
export { default as RiCodeLine } from './generated/RiCodeLine'
export { default as RiCodeSSlashLine } from './generated/RiCodeSSlashLine'
export { default as RiComputerLine } from './generated/RiComputerLine'
export { default as RiCrosshairLine } from './generated/RiCrosshairLine'
export { default as RiCss3Line } from './generated/RiCss3Line'
export { default as RiDashboardLine } from './generated/RiDashboardLine'
export { default as RiDatabase2Line } from './generated/RiDatabase2Line'
export { default as RiDatabaseLine } from './generated/RiDatabaseLine'
export { default as RiDiamondRingLine } from './generated/RiDiamondRingLine'
export { default as RiDiscountPercentLine } from './generated/RiDiscountPercentLine'
export { default as RiDollarCircleLine } from './generated/RiDollarCircleLine'
export { default as RiDownloadFill } from './generated/RiDownloadFill'
export { default as RiDownloadLine } from './generated/RiDownloadLine'
export { default as RiDumbbellLine } from './generated/RiDumbbellLine'
export { default as RiEmotionLine } from './generated/RiEmotionLine'
export { default as RiEmotionUnhappyLine } from './generated/RiEmotionUnhappyLine'
export { default as RiEqualizerFill } from './generated/RiEqualizerFill'
export { default as RiErrorWarningFill } from './generated/RiErrorWarningFill'
export { default as RiErrorWarningLine } from './generated/RiErrorWarningLine'
export { default as RiExchangeLine } from './generated/RiExchangeLine'
export { default as RiExternalLinkLine } from './generated/RiExternalLinkLine'
export { default as RiEyeFill } from './generated/RiEyeFill'
export { default as RiEyeOffFill } from './generated/RiEyeOffFill'
export { default as RiFacebookCircleLine } from './generated/RiFacebookCircleLine'
export { default as RiFacebookFill } from './generated/RiFacebookFill'
export { default as RiFeedbackLine } from './generated/RiFeedbackLine'
export { default as RiFile3Fill } from './generated/RiFile3Fill'
export { default as RiFileCopy2Line } from './generated/RiFileCopy2Line'
export { default as RiFileCopyLine } from './generated/RiFileCopyLine'
export { default as RiFileLine } from './generated/RiFileLine'
export { default as RiFileList3Line } from './generated/RiFileList3Line'
export { default as RiFileListLine } from './generated/RiFileListLine'
export { default as RiFileTextLine } from './generated/RiFileTextLine'
export { default as RiFileVideoFill } from './generated/RiFileVideoFill'
export { default as RiFilmFill } from './generated/RiFilmFill'
export { default as RiFilter3Line } from './generated/RiFilter3Line'
export { default as RiFilterLine } from './generated/RiFilterLine'
export { default as RiFireLine } from './generated/RiFireLine'
export { default as RiFirstAidKitLine } from './generated/RiFirstAidKitLine'
export { default as RiFlashlightLine } from './generated/RiFlashlightLine'
export { default as RiFlaskLine } from './generated/RiFlaskLine'
export { default as RiFlowChart } from './generated/RiFlowChart'
export { default as RiFocus2Line } from './generated/RiFocus2Line'
export { default as RiFolder2Line } from './generated/RiFolder2Line'
export { default as RiFullscreenLine } from './generated/RiFullscreenLine'
export { default as RiGhostLine } from './generated/RiGhostLine'
export { default as RiGiftLine } from './generated/RiGiftLine'
export { default as RiGithubFill } from './generated/RiGithubFill'
export { default as RiGlobalLine } from './generated/RiGlobalLine'
export { default as RiGraduationCapLine } from './generated/RiGraduationCapLine'
export { default as RiGroup2Line } from './generated/RiGroup2Line'
export { default as RiHandbagLine } from './generated/RiHandbagLine'
export { default as RiHeartFill } from './generated/RiHeartFill'
export { default as RiHeartLine } from './generated/RiHeartLine'
export { default as RiHistoryLine } from './generated/RiHistoryLine'
export { default as RiHome3Line } from './generated/RiHome3Line'
export { default as RiHome4Line } from './generated/RiHome4Line'
export { default as RiHourglassFill } from './generated/RiHourglassFill'
export { default as RiInformationFill } from './generated/RiInformationFill'
export { default as RiInformationLine } from './generated/RiInformationLine'
export { default as RiInstagramFill } from './generated/RiInstagramFill'
export { default as RiLandscapeLine } from './generated/RiLandscapeLine'
export { default as RiLayoutGridLine } from './generated/RiLayoutGridLine'
export { default as RiLightbulbFlashLine } from './generated/RiLightbulbFlashLine'
export { default as RiLightbulbLine } from './generated/RiLightbulbLine'
export { default as RiLineChartFill } from './generated/RiLineChartFill'
export { default as RiLineChartLine } from './generated/RiLineChartLine'
export { default as RiLinkedinBoxFill } from './generated/RiLinkedinBoxFill'
export { default as RiLinkedinFill } from './generated/RiLinkedinFill'
export { default as RiLinksLine } from './generated/RiLinksLine'
export { default as RiListCheck2 } from './generated/RiListCheck2'
export { default as RiListCheck3 } from './generated/RiListCheck3'
export { default as RiListUnordered } from './generated/RiListUnordered'
export { default as RiLiveFill } from './generated/RiLiveFill'
export { default as RiLoader2Fill } from './generated/RiLoader2Fill'
export { default as RiLoader4Line } from './generated/RiLoader4Line'
export { default as RiLoaderLine } from './generated/RiLoaderLine'
export { default as RiLockLine } from './generated/RiLockLine'
export { default as RiMagicLine } from './generated/RiMagicLine'
export { default as RiMailLine } from './generated/RiMailLine'
export { default as RiMap2Line } from './generated/RiMap2Line'
export { default as RiMapPinLine } from './generated/RiMapPinLine'
export { default as RiMedalLine } from './generated/RiMedalLine'
export { default as RiMedicineBottleLine } from './generated/RiMedicineBottleLine'
export { default as RiMegaphoneLine } from './generated/RiMegaphoneLine'
export { default as RiMenuLine } from './generated/RiMenuLine'
export { default as RiMindMap } from './generated/RiMindMap'
export { default as RiMoneyDollarCircleLine } from './generated/RiMoneyDollarCircleLine'
export { default as RiMoonLine } from './generated/RiMoonLine'
export { default as RiMountainLine } from './generated/RiMountainLine'
export { default as RiMouseLine } from './generated/RiMouseLine'
export { default as RiMovie2Line } from './generated/RiMovie2Line'
export { default as RiNewspaperLine } from './generated/RiNewspaperLine'
export { default as RiPagesLine } from './generated/RiPagesLine'
export { default as RiPaletteLine } from './generated/RiPaletteLine'
export { default as RiPauseFill } from './generated/RiPauseFill'
export { default as RiPercentLine } from './generated/RiPercentLine'
export { default as RiPieChartLine } from './generated/RiPieChartLine'
export { default as RiPinterestFill } from './generated/RiPinterestFill'
export { default as RiPlayFill } from './generated/RiPlayFill'
export { default as RiPresentationLine } from './generated/RiPresentationLine'
export { default as RiPriceTag3Line } from './generated/RiPriceTag3Line'
export { default as RiPriceTagLine } from './generated/RiPriceTagLine'
export { default as RiProductHuntFill } from './generated/RiProductHuntFill'
export { default as RiQuestionLine } from './generated/RiQuestionLine'
export { default as RiRedditFill } from './generated/RiRedditFill'
export { default as RiRepeatLine } from './generated/RiRepeatLine'
export { default as RiRewindFill } from './generated/RiRewindFill'
export { default as RiRobot2Line } from './generated/RiRobot2Line'
export { default as RiRocketLine } from './generated/RiRocketLine'
export { default as RiRouteLine } from './generated/RiRouteLine'
export { default as RiRulerFill } from './generated/RiRulerFill'
export { default as RiRunLine } from './generated/RiRunLine'
export { default as RiScales3Line } from './generated/RiScales3Line'
export { default as RiSearch2Line } from './generated/RiSearch2Line'
export { default as RiSearchEyeLine } from './generated/RiSearchEyeLine'
export { default as RiSearchLine } from './generated/RiSearchLine'
export { default as RiSeoLine } from './generated/RiSeoLine'
export { default as RiServiceLine } from './generated/RiServiceLine'
export { default as RiSettings3Line } from './generated/RiSettings3Line'
export { default as RiSettings4Line } from './generated/RiSettings4Line'
export { default as RiShapesLine } from './generated/RiShapesLine'
export { default as RiShareLine } from './generated/RiShareLine'
export { default as RiShieldCheckLine } from './generated/RiShieldCheckLine'
export { default as RiShieldLine } from './generated/RiShieldLine'
export { default as RiShoppingBag2Line } from './generated/RiShoppingBag2Line'
export { default as RiShoppingBasketLine } from './generated/RiShoppingBasketLine'
export { default as RiShoppingCart2Line } from './generated/RiShoppingCart2Line'
export { default as RiShoppingCartLine } from './generated/RiShoppingCartLine'
export { default as RiSignpostLine } from './generated/RiSignpostLine'
export { default as RiSmartphoneLine } from './generated/RiSmartphoneLine'
export { default as RiSortAsc } from './generated/RiSortAsc'
export { default as RiSortDesc } from './generated/RiSortDesc'
export { default as RiSparklesLine } from './generated/RiSparklesLine'
export { default as RiSparklingLine } from './generated/RiSparklingLine'
export { default as RiStackLine } from './generated/RiStackLine'
export { default as RiStarFill } from './generated/RiStarFill'
export { default as RiStarLine } from './generated/RiStarLine'
export { default as RiSubtractLine } from './generated/RiSubtractLine'
export { default as RiSunLine } from './generated/RiSunLine'
export { default as RiSurveyLine } from './generated/RiSurveyLine'
export { default as RiTableLine } from './generated/RiTableLine'
export { default as RiTargetLine } from './generated/RiTargetLine'
export { default as RiTeamLine } from './generated/RiTeamLine'
export { default as RiTestTubeLine } from './generated/RiTestTubeLine'
export { default as RiTiktokLine } from './generated/RiTiktokLine'
export { default as RiTimeFill } from './generated/RiTimeFill'
export { default as RiTimeLine } from './generated/RiTimeLine'
export { default as RiTimeLineBack } from './generated/RiTimeLineBack'
export { default as RiTimer2Line } from './generated/RiTimer2Line'
export { default as RiToolsFill } from './generated/RiToolsFill'
export { default as RiToolsLine } from './generated/RiToolsLine'
export { default as RiTrophyLine } from './generated/RiTrophyLine'
export { default as RiTwitterXFill } from './generated/RiTwitterXFill'
export { default as RiTwitterXLine } from './generated/RiTwitterXLine'
export { default as RiUserAddLine } from './generated/RiUserAddLine'
export { default as RiUserCommunityLine } from './generated/RiUserCommunityLine'
export { default as RiUserLine } from './generated/RiUserLine'
export { default as RiUserSearchLine } from './generated/RiUserSearchLine'
export { default as RiUsersLine } from './generated/RiUsersLine'
export { default as RiUserSmileLine } from './generated/RiUserSmileLine'
export { default as RiUserStarLine } from './generated/RiUserStarLine'
export { default as RiUserVoiceLine } from './generated/RiUserVoiceLine'
export { default as RiVerifiedBadgeLine } from './generated/RiVerifiedBadgeLine'
export { default as RiVideoLine } from './generated/RiVideoLine'
export { default as RiVideoOnFill } from './generated/RiVideoOnFill'
export { default as RiVimeoLine } from './generated/RiVimeoLine'
export { default as RiVipLine } from './generated/RiVipLine'
export { default as RiVolumeMuteFill } from './generated/RiVolumeMuteFill'
export { default as RiVolumeUpFill } from './generated/RiVolumeUpFill'
export { default as RiWallet3Line } from './generated/RiWallet3Line'
export { default as RiYoutubeFill } from './generated/RiYoutubeFill'
export { default as RiYoutubeLine } from './generated/RiYoutubeLine'
